import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// material
import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// ----------------------------------------------------------------------
import InteliconvoAi from '../../src/assets/InteliconvoAi.svg';

Logo.propTypes = {
    sx: PropTypes.object
};

export default function Logo({ sx }) {
    const navigate = useNavigate();
    const handleLogoClick = () => {
        navigate('/dashboard/demos', { replace: true });
    };
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ cursor: 'pointer', ...sx }}
            onClick={handleLogoClick}
        >
            <Box
                component="img"
                src={InteliconvoAi}
                alt="Inteliconvo Ai Logo"
                sx={{ width: 20, height: 20 }}
            />
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '100%',
                    letterSpacing: '0',
                    background: 'linear-gradient(90deg, #0053A6 0%, #04284C 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    display: 'inline-block',
                    paddingLeft: '5px'
                }}
                variant="body2"
                gutterBottom
            >
                inteliconvo
            </Typography>
        </Stack>
    );
}
